import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useSiteContent() {
  const { data, isLoading } = useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/public/site-content")).data,
    staleTime: 5 * 60 * 1000,
  });
  return { content: data || {}, isLoading };
}
